import React from 'react';
import { HStack, RadioGroup, Radio } from "@chakra-ui/react"
import { StepDetailsBaseProps } from '../models/StepDetailsBaseProps';
import { StepStateModel } from '../models/StepModel';


interface StepContainerProps {
    currentStepIdx: number;
    totalSteps: number;
    title: string;
    description: string;
    stepOptions?: any[];
    selectedStepOptionValue?: string | null;
    setSelectedStepOption?: (value: string | null) => void;
    children?: React.ReactNode; //typeof StepDetailsBase; //React.ReactNode;
    saveActiveStepState: (activeStep: number, progress: any) => void;
    setIsStepValid: (isValid: boolean) => void;
    stepsSavedState: StepStateModel[];
}

const StepContainer: React.FC<StepContainerProps> = (
    { 
        currentStepIdx, 
        totalSteps, 
        title, 
        description, 
        children, 
        stepOptions = [], 
        selectedStepOptionValue, 
        setSelectedStepOption,
        saveActiveStepState,
        setIsStepValid,
        stepsSavedState
    } : StepContainerProps
    ) => {

    
    const renderChildren = () => {
        const childrenNode = React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
                if (child.type === React.Fragment) {
                    console.log(`child is an empty Fragment element`);
                    setIsStepValid(true);
                } 
                if (typeof child.type === 'string') {
                    console.log(`child ${child.type} is an HTML element`);
                    setIsStepValid(true);
                } 
                if (typeof child.type === 'function') {

                    console.log(`${child.type.name} is a component`);

                    return React.cloneElement(child as React.ReactElement<StepDetailsBaseProps>, {
                        stepIdx: currentStepIdx,
                        saveActiveStepState,
                        setIsStepValid, 
                        stepsSavedState, 
                        selectedStepOptionValue,
                        stepOptions,
                        title, 
                        description
                    });

                }
            }
            return child;
        });
        
        return (
            <>
            {childrenNode}
            </>
        );
    };

    const StepOptionsComponent = () => {
        return (
            <RadioGroup value={selectedStepOptionValue?.toString()} onChange={setSelectedStepOption}>
                <HStack align="start">
                    {stepOptions?.map(({ optionValue, label, enabled }, index) => (
                        <Radio 
                            key={index} 
                            value={optionValue?.toString()} 
                            isDisabled={!enabled}
                            mr={5}>
                            {label}
                        </Radio>
                    ))}
                </HStack>
            </RadioGroup>
        )
    }

    return (
        <div className="step-container">
            <div className="step-header">
                <h2>
                    Step {currentStepIdx + 1} of {totalSteps}
                </h2>
            </div>
            <h3 className="step-header">{title}</h3>

            <StepOptionsComponent />
            
            <h4>{description}</h4>
            <div className="step-content">
                {renderChildren()}
            </div>
        </div>
    );
};

export default StepContainer;